<div class="card-body p-4">
    <form [formGroup]="form">
        <div class="mb-2">
            <label for="verificationCode" class="form-label">Enter verification code</label>
            <input type="text" id="verificationCode" formControlName="verificationCode" class="form-control" placeholder="ddd-ddd" verificationCode>
        </div>
        @if(error) {
            <div class="">
                <span class="text-danger">{{error}}</span>
            </div>
        }
        <div class="text-center">
            @if(loading) {
                <button type="button" (click)="verify()" class="btn btn-primary mt-3" disabled>
                <span class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
                    Verify
                </button>
            }
            @else {
                <button type="button" (click)="verify()" class="btn btn-primary mt-3">Verify</button>
            }
        </div>
    </form>
</div>